import { render } from "./NModalWindow.vue?vue&type=template&id=bfa1bc2e&ts=true"
import script from "./NModalWindow.vue?vue&type=script&lang=ts"
export * from "./NModalWindow.vue?vue&type=script&lang=ts"

import "./NModalWindow.vue?vue&type=style&index=0&id=bfa1bc2e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__